module.exports = __webpack_public_path__ + "static/media/UserNotFound.a6fb0e98.svg";